import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mtcloud",
  "use": "icon-mtcloud-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mtcloud\"><path fill=\"#003e9e\" d=\"M44,16.1c-4.8,0-9.1,2.1-12,5.5c-2.9-3.4-7.2-5.5-12-5.5c-8.8,0-15.9,7.1-15.9,15.9c0,8.8,7.1,15.9,15.9,15.9\tc4.8,0,9.1-2.1,12-5.5c2.9,3.4,7.2,5.5,12,5.5c8.8,0,15.9-7.1,15.9-15.9C59.9,23.2,52.8,16.1,44,16.1z\" /><path fill=\"#fff\" d=\"M37.6,28.5l-9.1,9.1c-0.6,0.6-1.5,0.6-2.1,0l0,0c-0.6-0.6-0.6-1.5,0-2.1l9.1-9.1c0.6-0.6,1.5-0.6,2.1,0l0,0\tC38.2,27,38.2,27.9,37.6,28.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol